module.exports = __webpack_public_path__ + "static/img/spotify.250fd78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spotify.jpg
// module id = U6xv
// module chunks = 0